import React, { Component } from "react";
//import Adminmenu from '../Menu/Adminmenu';
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import { token } from '../../Actions/AuthAction';
import { GetCourses, Changestatuscourse } from "../../Actions/CommonAction";
import { showLoader, hideLoader } from '../../../utils';

class List extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      getdatalist: [],
      totalCount: 0,
      limit: 5,
      currentPage: 0,
    };
  }

  componentDidMount() {
    GetCourses({ status: "" }).then((res) => {
      this.setState({
        getdatalist: res.data.slice(this.state.currentPage, this.state.limit),
        original: res.data,
        totalCount: res.data.length,
        limit:
          this.state.limit >= res.data.length
            ? res.data.length
            : this.state.limit,
      });
    });
  }

  OnCheckboxCourseStatusChange = (e, id) => {
    Swal.fire({
      title: `Are you sure, you want to mark this sector as ${e.target.checked ? "InActive" : "Active"
        } ?`,
      text: "",
      icon: "",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        const { getdatalist } = this.state;
        getdatalist.map((item) => {
          if (item.id === id) {
            item.status = e.target.checked;
          }
        });
        this.setState({ getdatalist }, () => {
          Changestatuscourse({
            loginusertoken: token(),
            id: id,
            status: !e.target.checked,
          }).then((res) => {
            Swal.fire("Success", res.message, "success");
          });
        });
      }
    });
  };

  handlePageClick = (data) => {
    console.log("selected", data);
    let selected = data.selected;
    let startIndex = selected * this.state.limit;
    let endIndex = startIndex + this.state.limit;
    let result = this.state.original.slice(startIndex, endIndex);
    this.setState(
      {
        currentPage: selected,
        getdatalist: result,
      },
      () => {
        //this.getToolCategories();
      }
    );
  };

  filterOnSearch = (e) => {
    const { value } = e.target;
    let result = this.state.original.filter((item) => {
      if (!value) return true;
      return item.name.toLowerCase().includes(value.toLowerCase());
    });
    this.setState({
      getdatalist: result.slice(this.state.currentPage, this.state.limit),
    });
  };

  Editcourse = (e, item) => {
    const id = item.id;
    this.props.history.push({
      pathname: `/mastercoursesadd/${id}`,
      state: {
        detail: item,
      },
    });
  };

  filterdata = (data) => {
    this.setState({
      currentPage: 0
    })

    const model = {
      status: data
    }
    showLoader(this);
    GetCourses(model)
      .then(res => {
        hideLoader(this)
        this.setState({
          getdatalist: res.data.slice(this.state.currentPage, this.state.limit),
          original: res.data,
          totalCount: res.data.length,
        })
      }).catch(e => hideLoader(this))

  }


  render() {
    return (
      <>
        <div className="row mb-4">
          <div className="col-md-12">
            <h4 className="table_heading position-relative">COURSES LIST</h4>
          </div>
        </div>
        <div className="card table_card mb-4">
          <div className="card-body">
            <div className="">
              <div className="d-flex justify-content-end mb-3">
                <Link
                  className="btn btn-primary-custom mx-2"
                  to="/mastercoursesadd"
                >
                  ADD
                </Link>
              </div>
              <form className="d-flex justify-content-between form-group tableform">
                <div>
                  <select
                    onChange={(e) => this.filterdata(e.target.value)}
                    className="form-control"
                  >
                    <option value="">All</option>
                    <option value="1">Active</option>
                    <option value="0">InActive</option>
                  </select>
                </div>
                <div className="search-box mb-2">
                  <input
                    className="search-text"
                    type="text"
                    placeholder="Search"
                    name="search"
                    onChange={this.filterOnSearch}
                  />
                  <button
                    type="button"
                    className="search-btn"
                    onClick={(e) => this.searchdata(this.state.search)}
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>
              </form>
            </div>
            <div className="table-responsive">
              <table
                className="table table-bordered"
                width="100%"
                cellspacing="0"
              >
                <thead>
                  <tr>
                    <th scope="col">
                      S.No. <br />
                    </th>
                    <th scope="col">Name</th>
                    <th scope="col" className="text-center">
                      Status
                      <br />
                    </th>
                    <th scope="col" className="text-center">
                      Action
                      <br />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.getdatalist
                    ? this.state.getdatalist.map((item, i) => (
                      <tr>
                        <td>
                          {this.state.currentPage * this.state.limit + ++i}
                        </td>
                        <td>{item.name}</td>

                        <td className="text-center">
                          <label className="switch switchyes">
                            <input
                              type="checkbox"
                              checked={item.status ? 0 : 1}
                              onChange={(e) =>
                                this.OnCheckboxCourseStatusChange(e, item.id)
                              }
                            />
                            <span className="slidernormal round"></span>
                          </label>
                        </td>
                        <td className="text-center">
                          <span onClick={(e) => this.Editcourse(e, item)} className="cursor-pointer"><i class="bi bi-pencil-fill"></i> Edit</span>
                        </td>
                      </tr>
                    ))
                    : null}
                </tbody>
              </table>
            </div>

            {this.state.getdatalist.length != 0 && (
              <div className="d-flex justify-content-between">
                <h6>
                  <span>{`${this.state.currentPage
                    ? this.state.currentPage * this.state.limit + 1
                    : 1
                    }-${this.state.getdatalist.length < this.state.limit
                      ? this.state.totalCount
                      : (this.state.currentPage + 1) * this.state.limit
                    }`}</span>{" "}
                  <span>/ {this.state.totalCount} Search Results</span>
                </h6>
                <div class="pagination">
                  <ReactPaginate
                    previousLabel={
                      <i
                        className="fa fa-angle-double-left"
                        aria-hidden="true"
                      ></i>
                    }
                    nextLabel={
                      <i
                        className="fa fa-angle-double-right"
                        aria-hidden="true"
                      ></i>
                    }
                    pageCount={
                      this.state.totalCount % this.state.limit === 0
                        ? parseInt(this.state.totalCount / this.state.limit)
                        : parseInt(this.state.totalCount / this.state.limit) + 1
                    }
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={this.state.limit}
                    onPageChange={this.handlePageClick}
                    activeClassName={"active"}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default List;
